<template>
  <v-fade-transition mode="out-in">
    <router-view v-if="$store.state.user || render" />
    <loading-screen v-else />
  </v-fade-transition>
</template>

<script>

import axios from "axios";
export default {
  name: "App",
  components: {
    "loading-screen": () => import("./components/Utils/LoadingScreen.vue"),
  },
  data: () => ({
    render: false,
  }),
  created: function() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("token");
    const email = urlParams.get("email");
    const password = urlParams.get("pass");

    this.render = true;
    if (token) {
      localStorage.setItem("token", token);
      location.replace("/");
        this.$store.commit("setExpiryDate");
    } else if (email && password) {
      this.logout();
      let data = {
        email: email,
        password: password,
      };

      localStorage.removeItem("token");
      localStorage.removeItem("vuex");
      localStorage.removeItem("_secure__ls__metadata");
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setEmail", null);
      this.$store.dispatch("setEmp", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.$store.state.expiryDate = null;

      this.axiosCall("/auth/portalLogin", "POST", data).then((res) => {
        if (res.data.status) {
          localStorage.setItem("token", res.data.token);
          this.$store.commit("setExpiryDate");

          setTimeout(() => {
            axios({
              method: "GET",
              url: process.env.VUE_APP_SERVER + "/employee/my-details",

              headers: { Authorization: `Bearer ${res.data.token}` },
            }).then((resp) => {
              this.$store.dispatch("setEmp", resp.data);
              location.replace("/");
              // location.reload();
            });
          }, 500);
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.message;
          this.fadeAwayMessage.header = "System Message";
        }
      });
    } else {
      this.getUser();
    }
   
  },

   mounted() {
    
  },
  methods: {
    setEmp(){
        this.axiosCall("/employee/my-details", "GET").then((res) => {
          this.$store.dispatch("setEmp", res.data);
        });
    },

   getUser() {
      
      if (localStorage.getItem("token")) {
        this.setEmp();
       
        this.axiosCall("/auth/current_user", "GET")
          .then((res) => {
         if (res.data.statusCode != 401) {
              let data = res.data.userdetail;

              this.$store.dispatch("setUser", data);
              this.$store.dispatch("setIsAuthenticated", 1);

              if (this.$route.path === "/login") {
                if (data.usertype.id == 1) {
                  this.$router.push("/admin/dashboard");
                } else if (data.usertype.id == 2) {
                  if (data.user.user_roleID == 5) {
                    this.$router.push("/superadmin/dashboard");
                  } else {
                    this.$router.push("/employee/dashboard");
                  }
                } else if (data.usertype.id == 3) {
                  this.$router.push("/security/dashboard");
                } else if (data.usertype.id == 4) {
                  this.$router.push("/auditor/dashboard");
                }
              }
             
            } else {
              this.$store.dispatch("setUser", null);
              this.$store.dispatch("setIsAuthenticated", 0);
               localStorage.removeItem("token");
              localStorage.removeItem("vuex");
              localStorage.removeItem("_secure__ls__metadata");
              setTimeout(() => {
                location.reload();
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
            this.render = true;
          });
      } else {
        this.render = true;
      }
     
    },


    
  },
};
</script>
<style>
/* SCROLL BAR CUSTOMIZE*/
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(206, 196, 196);
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #9da19c;
  border-radius: 5px;
}
</style>
